module.exports = __webpack_public_path__ + "img/help.11fc0625.png";